import React from 'react';
import { Icon } from '@redturtle/iovisit-theme/components';
import config from '@plone/registry';

const HeaderTopLink = () => {
  return (
    <div className="iv--header-top-info">
      {config.settings.iovisit.topLink?.text &&
        (config.settings.iovisit.topLink?.url ? (
          <a
            href={config.settings.iovisit.topLink.url}
            className="iv--header-top-externallink"
            rel="noopener noreferrer"
            target="_blank"
          >
            <Icon prefix="fas" icon="external-link-alt" className="icon" />
            <span>{config.settings.iovisit.topLink.text}</span>
          </a>
        ) : (
          <div>
            <span>{config.settings.iovisit.topLink.text}</span>
          </div>
        ))}
    </div>
  );
};

export default HeaderTopLink;
